import { render, staticRenderFns } from "./App.vue?vue&type=template&id=ba327cd8&"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&lang=css&"
import style1 from "@damoursystems/curricular-visualization/dist/curricular-visualization.min.css?vue&type=style&index=1&lang=css&"
import style2 from "@fortawesome/fontawesome-free/css/solid.min.css?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports